export default "__VITE_ASSET__f7dad1be__"